/** 표시용 문자열 다듬기. */

/** 숫자만 남겨 010-1234-5678 모양으로. 입력 중에도 자연스럽게 끊어집니다. */
export const formatPhone = (value: string): string => {
    const numbers = value.replace(/[^0-9]/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
};

/** 모임 응답에서 일정 꺼내기.
 *  응답 모양이 세 가지(schedule / confirmedSchedule / 평평한 startDatetime)라
 *  화면마다 같은 분기를 복사해 쓰고 있었습니다. */
export const getMeetingSchedule = (meeting: any): { startDatetime: string; endDatetime?: string } | null => {
    if (meeting?.schedule?.startDatetime) return meeting.schedule;
    if (meeting?.confirmedSchedule?.startDatetime) return meeting.confirmedSchedule;
    if (meeting?.startDatetime) return { startDatetime: meeting.startDatetime, endDatetime: meeting.endDatetime };
    return null;
};
